/**
 * CDN base hostname/path from env (no trailing slash required).
 * @see NEXT_PUBLIC_CDN_URL in app `.env.example` for why it exists.
 */
function cdnBaseFromEnv(): string {
  return process.env.NEXT_PUBLIC_CDN_URL ?? "";
}

/** Full CDN URL including static prefix; used by `assetPrefix`, image loader, and `toCdnAssetUrl`. */
export function getCdnUrl(): string {
  const base = cdnBaseFromEnv();
  if (!base || !process.env.NEXT_PUBLIC_CDN_STATIC_PREFIX) return "";
  return `${base}${process.env.NEXT_PUBLIC_CDN_STATIC_PREFIX}`;
}

/** Evaluated once per process (same as previous `export const CDN_URL = ...` pattern). */
export const CDN_URL = getCdnUrl();

export function toCdnAssetUrl(src: string): string {
  if (!src || src.startsWith("data:") || /^https?:\/\//i.test(src)) {
    return src;
  }

  const normalizedSrc = src.startsWith("/") ? src : `/${src}`;
  return CDN_URL ? `${CDN_URL}${normalizedSrc}` : normalizedSrc;
}
